import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://codelens.epoch.co/openshield/';

class SshApiService {
  async getSshAlerts(agentId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/alerts/ssh/${agentId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching SSH alerts for agent ${agentId}:`, error);
      throw error;
    }
  }
}

const sshApiService = new SshApiService();
export default sshApiService;
